<div
  class="snackbar_content"
  [ngClass]="panelClass"
>
  <div class="snackbar_message">{{ message }}</div>
  <div class="snackbar_close">
    <button
      *ngIf="closeString"
      (click)="close()"
      mat-button
      [ngClass]="closeClass"
      type="button"
    >
      <span *ngIf="durationSecD" class="duration">{{ durationSecD }}</span>&nbsp;<mat-icon svgIcon="close"></mat-icon>
    </button>
  </div>
</div>
